// import { useState } from "react";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Autoplay, Navigation } from "swiper/modules";

// import "swiper/css";
// import "swiper/css/navigation";

// import perfumeData from "../../data/perfumeData";
// import ProductCard from "../RudrakshaSection/ProductCard";

// const banners = [
//   "https://i.pinimg.com/1200x/71/c6/73/71c67392c35741a536f1c35e5c0c6586.jpg",
//   "https://i.pinimg.com/736x/44/cd/00/44cd00a0ba6a57c69a4dc5c3f4adf797.jpg",
//   "https://i.pinimg.com/736x/58/19/9c/58199cf981a3b702c49eddce8c9cb778.jpg",
// ];

// export default function PerfumeSection() {
//   const tabs = Object.keys(perfumeData);

//   const [activeTab, setActiveTab] = useState(tabs[0]);

//   return (
//     <section className="rudraksha-section perfume-section">
//       <div className="container">

//         <div className="section-top">

//           <h2>Explore Premium Fragrances</h2>

//           <div className="tabs">
//             {tabs.map((tab) => (
//               <button
//                 key={tab}
//                 className={activeTab === tab ? "active" : ""}
//                 onClick={() => setActiveTab(tab)}
//               >
//                 {perfumeData[tab][0]?.category || tab}
//               </button>
//             ))}
//           </div>

//         </div>

//         <div className="section-content">

//           {/* LEFT BANNER */}
//           <div className="left-banner">

//             <Swiper
//               modules={[Autoplay]}
//               loop
//               autoplay={{
//                 delay: 3000,
//                 disableOnInteraction: false,
//               }}
//             >
//               {banners.map((img, index) => (
//                 <SwiperSlide key={index}>
//                   <img
//                     src={img}
//                     alt="Premium Perfume"
//                   />
//                 </SwiperSlide>
//               ))}
//             </Swiper>

//           </div>

//           {/* RIGHT PRODUCTS */}
//           <div className="right-products">

//             <Swiper
//               modules={[Navigation, Autoplay]}
//               navigation
//               loop={true}
//               spaceBetween={10}
//               slidesPerView={3}
//               breakpoints={{
//                 0: {
//                   slidesPerView: 2,
//                   spaceBetween: 10,
//                 },
//                 576: {
//                   slidesPerView: 2,
//                   spaceBetween: 12,
//                 },
//                 768: {
//                   slidesPerView: 2,
//                   spaceBetween: 15,
//                 },
//                 1200: {
//                   slidesPerView: 3,
//                   spaceBetween: 20,
//                 },
//               }}
//             >
//               {perfumeData[activeTab]?.map((product) => (
//                 <SwiperSlide key={product.id}>
//                   <ProductCard product={product} />
//                 </SwiperSlide>
//               ))}
//             </Swiper>

//           </div>

//         </div>

//       </div>
//     </section>
//   );
// }






// api integrate 



import { useEffect, useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper/modules";

import "swiper/css";
import "swiper/css/navigation";

import ProductCard from "../RudrakshaSection/ProductCard";
import Loader from "../Loader/Loader";
import { getProducts } from "../../api/productApi";
import { getCategories } from "../../api/getCategories";
import API_BASE_URL from "../../config";

// =====================================================
// PERFUME CATEGORY SLUG
// =====================================================

const PERFUME_CATEGORY_SLUG = "perfumes";

// =====================================================
// BANNERS
// =====================================================

const banners = [
  "https://i.pinimg.com/1200x/71/c6/73/71c67392c35741a536f1c35e5c0c6586.jpg",
  "https://i.pinimg.com/736x/44/cd/00/44cd00a0ba6a57c69a4dc5c3f4adf797.jpg",
  "https://i.pinimg.com/736x/58/19/9c/58199cf981a3b702c49eddce8c9cb778.jpg",
];

export default function PerfumeSection() {
  // ===================================================
  // STATES
  // ===================================================

  const [perfumeCategory, setPerfumeCategory] = useState(null);

  const [subcategories, setSubcategories] = useState([]);

  const [activeSubcategory, setActiveSubcategory] = useState(null);

  const [products, setProducts] = useState([]);

  const [loadingCategories, setLoadingCategories] = useState(true);

  const [loadingProducts, setLoadingProducts] = useState(false);

  // ===================================================
  // GET PERFUME CATEGORY + SUBCATEGORIES
  // ===================================================

  useEffect(() => {
    const fetchPerfumeCategory = async () => {
      try {
        setLoadingCategories(true);

        const result = await getCategories();

        console.log("All Categories:", result);

        if (!result?.success) {
          setPerfumeCategory(null);
          setSubcategories([]);
          return;
        }

        const categories = result?.data || [];

        // Find Perfumes category by slug
        const perfume = categories.find(
          (category) =>
            category?.slug?.toLowerCase() ===
            PERFUME_CATEGORY_SLUG.toLowerCase()
        );

        console.log("Perfume Category:", perfume);

        if (!perfume) {
          console.error(
            "Perfumes category not found"
          );

          setPerfumeCategory(null);
          setSubcategories([]);

          return;
        }

        setPerfumeCategory(perfume);

        // If subcategories are already included
        if (Array.isArray(perfume.subcategories)) {
          setSubcategories(perfume.subcategories);
        } else {
          // Otherwise fetch subcategories separately
          const subResponse = await fetch(
            `${API_BASE_URL}/categories/${perfume.id}/subcategories`
          );

          const subResult = await subResponse.json();

          console.log(
            "Perfume Subcategories:",
            subResult
          );

          if (subResult?.success) {
            setSubcategories(
              subResult.data || []
            );
          } else {
            setSubcategories([]);
          }
        }
      } catch (error) {
        console.error(
          "Perfume Category API Error:",
          error
        );

        setPerfumeCategory(null);
        setSubcategories([]);
      } finally {
        setLoadingCategories(false);
      }
    };

    fetchPerfumeCategory();
  }, []);

  // ===================================================
  // GET ALL PERFUME PRODUCTS
  // ===================================================

  const fetchAllProducts = async (
    categoryId
  ) => {
    try {
      if (!categoryId) return;

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: categoryId,
        page: 1,
        limit: 12,
      });

      console.log(
        "All Perfume Products:",
        result
      );

      if (result?.success) {
        setProducts(
          result?.data?.products || []
        );
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(
        "Perfume Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  // ===================================================
  // GET PRODUCTS BY SUBCATEGORY
  // ===================================================

  const fetchProductsBySubcategory = async (
    subcategoryId
  ) => {
    try {
      if (
        !perfumeCategory?.id ||
        !subcategoryId
      ) {
        return;
      }

      setLoadingProducts(true);

      const result = await getProducts({
        categoryId: perfumeCategory.id,
        subcategoryId: subcategoryId,
        page: 1,
        limit: 12,
      });

      console.log(
        "Perfume Products By Subcategory:",
        result
      );

      if (result?.success) {
        setProducts(
          result?.data?.products || []
        );
      } else {
        setProducts([]);
      }
    } catch (error) {
      console.error(
        "Perfume Subcategory Products API Error:",
        error
      );

      setProducts([]);
    } finally {
      setLoadingProducts(false);
    }
  };

  // ===================================================
  // FETCH INITIAL PRODUCTS
  // ===================================================

  useEffect(() => {
    if (perfumeCategory?.id) {
      setActiveSubcategory(null);

      fetchAllProducts(
        perfumeCategory.id
      );
    }
  }, [perfumeCategory]);

  // ===================================================
  // SUBCATEGORY CLICK
  // ===================================================

  const handleSubcategoryClick = (
    subcategory
  ) => {
    if (!subcategory?.id) return;

    setActiveSubcategory(
      subcategory.id
    );

    fetchProductsBySubcategory(
      subcategory.id
    );
  };

  // ===================================================
  // ALL PERFUMES CLICK
  // ===================================================

  const handleAllClick = () => {
    if (!perfumeCategory?.id) return;

    setActiveSubcategory(null);

    fetchAllProducts(
      perfumeCategory.id
    );
  };

  // ===================================================
  // RENDER
  // ===================================================

  return (
    <section className="rudraksha-section perfume-section">

      <div className="container">

        {/* =================================================
            TOP
        ================================================= */}

        <div className="section-top">

          <h2>
            Explore Premium Fragrances
          </h2>

          {/* =================================================
              TABS
          ================================================= */}

          <div className="tabs">

            {/* ALL PERFUMES */}

            <button
              type="button"
              className={
                activeSubcategory === null
                  ? "active"
                  : ""
              }
              onClick={handleAllClick}
              disabled={
                loadingCategories ||
                !perfumeCategory
              }
            >
              All Perfumes
            </button>

            {/* API SUBCATEGORIES */}

            {!loadingCategories &&
              subcategories.map(
                (subcategory) => (
                  <button
                    type="button"
                    key={subcategory.id}
                    className={
                      activeSubcategory ===
                      subcategory.id
                        ? "active"
                        : ""
                    }
                    onClick={() =>
                      handleSubcategoryClick(
                        subcategory
                      )
                    }
                  >
                    {subcategory.name}
                  </button>
                )
              )}

          </div>

        </div>

        {/* =================================================
            CONTENT
        ================================================= */}

        <div className="section-content">

          {/* =================================================
              LEFT BANNER
          ================================================= */}

          <div className="left-banner">

            <Swiper
              modules={[Autoplay]}
              loop
              autoplay={{
                delay: 3000,
                disableOnInteraction: false,
              }}
            >
              {banners.map(
                (image, index) => (
                  <SwiperSlide
                    key={index}
                  >
                    <img
                      src={image}
                      alt="Premium Perfume"
                    />
                  </SwiperSlide>
                )
              )}
            </Swiper>

          </div>

          {/* =================================================
              RIGHT PRODUCTS
          ================================================= */}

          <div className="right-products">

            {/* LOADING */}

            {loadingCategories ||
            loadingProducts ? (
              <div className="loading">
                <Loader label="Loading perfumes..." size={56} />
              </div>
            ) : products.length === 0 ? (

              /* NO PRODUCTS */

              <div className="loading">
                No perfumes found
              </div>

            ) : (

              <Swiper
                modules={[
                  Navigation,
                  Autoplay,
                ]}
                navigation
                loop={
                  products.length > 3
                }
                spaceBetween={10}
                slidesPerView={3}
                breakpoints={{
                  0: {
                    slidesPerView: 2,
                    spaceBetween: 10,
                  },

                  576: {
                    slidesPerView: 2,
                    spaceBetween: 12,
                  },

                  768: {
                    slidesPerView: 2,
                    spaceBetween: 15,
                  },

                  1200: {
                    slidesPerView: 3,
                    spaceBetween: 20,
                  },
                }}
              >

                {products.map(
                  (product) => (
                    <SwiperSlide
                      key={product.id}
                    >
                      <ProductCard
                        product={product}
                      />
                    </SwiperSlide>
                  )
                )}

              </Swiper>

            )}

          </div>

        </div>

      </div>

    </section>
  );
}


